import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      // Não refazer queries quando a aba volta a ter foco. A Anny relatou
      // perda de dados ao trocar para outra aba e voltar — refetch agressivo
      // soma ruído visual em modais de cadastro longos. Quem precisar de
      // dado fresco invalida explicitamente após mutação.
      refetchOnWindowFocus: false,
    },
  },
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
